module.exports = "/lucky-balls/img/infobox/info_Box_001.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_001.png
// module id = 1066
// module chunks = 0